<template>
  <div id="app">
    <universal-navigator />
    <router-view></router-view>
  </div>
</template>

<script>
import User from './services/request/user';
import { shouldRedirectToRebrandedDomain, redirectToRebrandedUrl } from './config/rebrand/helpers';

const UserRequest = new User();

export default {
  name: 'app',
  data() {
    return {
    };
  },
  beforeCreate() {
    if (shouldRedirectToRebrandedDomain) {
      redirectToRebrandedUrl();
    }
  },
  mounted() {
    if (!this.$router.currentRoute.fullPath.match('logout')) {
      UserRequest.identifier()
        .then((response) => {
          this.$ga.set('userId', response.data);
          this.$ga.page(this.$router);
        });
    }
  },
};
</script>

<style lang="scss">
@import './assets/scss/main';

:root {
  font-size: var(--text-2);
  height: auto;
}
[role=MenuItem] {
  span {
    font-size: var(--text-2);
  }
}
[role=SubmenuItem] {
  font-size: var(--text-2);
  padding: 8px 0px 0px 0px;
}
hot-avatar {
  font-size: var(--text-1, 0.75rem)
}
.dropdown-header {
  text-align: -webkit-center;
}
.profile-drawer {
  &__menu-header {
    &__user-info {
      p {
        padding: 2px 0px 5px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?4a828653